import { ResolveDrawerParams, ResolveParams } from 'src/core/models/routing';
import { IDynamicFilterItem } from 'src/stores/core/models';
import useRouterUtils from 'src/core/router-utils/route-utils';
import {
  getPaginationBasedOnUserPreferences,
  getDynamicFiltersUserPreferences,
  getFiltersFromUserPreferences,
} from 'src/core/utils/user-preferences-utils';
import { AppCoreEnums } from '../shared/enums';
import { RouteLocationNormalized } from 'vue-router';
import useUserPreferences from '../composable/use-user-preferences';

export default () => {
  const {
    getFiltersPreferenceKey,
    getPaginationPreferenceKey,
    getDynamicFiltersPreferenceKey,
    getDrawerPaginationPreferenceKey,
  } = useUserPreferences();

  const { allPaginationContainerTypes, allDynamicFiltersContainerTypes } = useRouterUtils();

  const updateResolveParamsBasedOnUserPreferences = (
    toRoute: RouteLocationNormalized,
    resolveParams: ResolveParams,
    containerType: AppCoreEnums.ContainerType,
    defaultDynamicFilters: IDynamicFilterItem[]
  ) => {
    // Pagination

    const hasContainerPagination = allPaginationContainerTypes.includes(containerType);
    if (hasContainerPagination) {
      resolveParams.pagination =
        resolveParams.pagination || getPaginationBasedOnUserPreferences(getPaginationPreferenceKey(containerType, toRoute));
    }

    // Dynamic filters
    const hasContainerDynamicFilters = allDynamicFiltersContainerTypes.includes(containerType);
    if (hasContainerDynamicFilters) {
      const dynamicFiltersUserPreference = getDynamicFiltersUserPreferences(
        getDynamicFiltersPreferenceKey(containerType, toRoute)
      );
      resolveParams.initialDynamicFilters = dynamicFiltersUserPreference || defaultDynamicFilters || [];

      if (!dynamicFiltersUserPreference && resolveParams.pagination) resolveParams.pagination.page = 1;
    }

    // Filters
    const hasContainerFilters = allPaginationContainerTypes.includes(containerType);
    if (hasContainerFilters) {
      const filtersFromUserPreference = getFiltersFromUserPreferences(getFiltersPreferenceKey(containerType));
      resolveParams.initialFiltersFromUserPreferences = filtersFromUserPreference;

      if (!filtersFromUserPreference && resolveParams.pagination) resolveParams.pagination.page = 1;
    }
  };

  const updateResolveDrawerParamsBasedOnUserPreferences = (resolveDrawerParams: ResolveDrawerParams) => {
    if (!resolveDrawerParams.resolveParams.pagination) {
      resolveDrawerParams.resolveParams.pagination = getPaginationBasedOnUserPreferences(
        getDrawerPaginationPreferenceKey(resolveDrawerParams.idDrawer)
      );
      resolveDrawerParams.resolveParams.pagination!.page = 1;
    }
  };

  return {
    updateResolveParamsBasedOnUserPreferences,
    updateResolveDrawerParamsBasedOnUserPreferences,
  };
};
